import EmailTemplatesCreation from './container/index';

export default EmailTemplatesCreation;



// WEBPACK FOOTER //
// ./src/views/email/emailTemplatesCreation/index.js